import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">おかやまリフォーム株式会社</h3>
            <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
              岡山市・倉敷市を中心に、住宅リフォーム・店舗工事・修繕工事を手がける地域密着型企業です。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">クイックリンク</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  ホーム
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  サービス
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  求人情報
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  ブログ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">サービス</h3>
            <ul className="space-y-2 text-xs sm:text-sm text-gray-400">
              <li>住宅リフォーム</li>
              <li>店舗工事</li>
              <li>修繕工事</li>
              <li>外壁・屋根工事</li>
              <li>水回りリフォーム</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">お問い合わせ</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-400">
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-0.5 flex-shrink-0"></i>
                <a href="tel:086-012-3456" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  086-012-3456
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span className="break-all">info@okayama-reform.co.jp</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span>岡山市北区○○町1-2-3</span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span>9:00〜18:00<br />（日曜・祝日定休）</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              &copy; 2024 おかやまリフォーム株式会社. All rights reserved.
            </p>
            <div className="flex items-center gap-2">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
